import { useState } from "react";
import { FaVideo } from "react-icons/fa";

const ProductActionsExtra = ({ productName }) => {

  const [showDemoModal, setShowDemoModal] = useState(false);

  const [form, setForm] = useState({
    name: "",
    phone: "",
    demoType: "",
    message: ""
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const whatsappNumber = "919834704067";
 const productUrl = window.location.href;
    const text = `Hello,

I want a demo for this product.

Product: ${productName}
Product Link: ${productUrl}
Name: ${form.name}
Phone: ${form.phone}

Preferred Demo Type: ${form.demoType}

Message: ${form.message || "No message"}

Please share the demo.`;

    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(text)}`;

    window.open(url, "_blank");

    setShowDemoModal(false);

    setForm({
      name: "",
      phone: "",
      demoType: "",
      message: ""
    });
  };

  return (
    <div className="mt-6 space-y-2">

      {/* Button */}
      <button
        onClick={() => setShowDemoModal(true)}
        className="w-full flex items-center justify-center gap-2 border border-black py-2 text-sm hover:bg-black hover:text-white transition"
      >
        <FaVideo />
        Request Product Demo
      </button>

      {/* Trust text */}
      <p className="text-xs text-gray-500 text-center">
        Get fabric feel, fitting and styling details before buying.
      </p>

      {/* Modal */}
      {showDemoModal && (

        <div
          className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4"
          onClick={() => setShowDemoModal(false)}
        >

          {/* Modal Content */}
          <div
            className="bg-white w-full max-w-md rounded-lg p-5 relative"
            onClick={(e) => e.stopPropagation()}
          >

            <button
              onClick={() => setShowDemoModal(false)}
              className="absolute right-4 top-4 text-lg"
            >
              ×
            </button>

            <h2 className="text-lg font-medium mb-4">
              Request Product Demo
            </h2>

            <form onSubmit={handleSubmit} className="space-y-3">

              {/* Name */}
              <div>
                <label className="text-xs text-gray-600">
                  Your Name <span className="text-red-500">*</span>
                </label>

                <input
                  type="text"
                  name="name"
                  required
                  value={form.name}
                  onChange={handleChange}
                  className="w-full border p-2 text-sm mt-1"
                />
              </div>

              {/* Phone */}
              <div>
                <label className="text-xs text-gray-600">
                  Phone Number <span className="text-red-500">*</span>
                </label>

                <input
                  type="tel"
                  name="phone"
                  required
                  value={form.phone}
                  onChange={handleChange}
                  className="w-full border p-2 text-sm mt-1"
                />
              </div>

              {/* Demo Type */}
              <div>
                <label className="text-xs text-gray-600">
                  Preferred Demo Type <span className="text-red-500">*</span>
                </label>

                <select
                  name="demoType"
                  required
                  value={form.demoType}
                  onChange={handleChange}
                  className="w-full border p-2 text-sm mt-1"
                >
                  <option value="">Select demo type</option>
                  <option value="Recorded Video">📹 Recorded Video</option>
                  <option value="Live Video Call">📞 Live Video Call</option>
                  <option value="Fabric Closeup">🔍 Fabric Close-up</option>
                </select>
              </div>

              {/* Message */}
              <div>
                <label className="text-xs text-gray-600">
                  Message (optional)
                </label>

                <textarea
                  name="message"
                  rows="3"
                  value={form.message}
                  onChange={handleChange}
                  className="w-full border p-2 text-sm mt-1 resize-none h-24"
                  placeholder="Any message..."
                />
              </div>

              {/* Submit */}
              <button
                type="submit"
                className="w-full bg-black text-white py-2 text-sm hover:opacity-90"
              >
                Send Demo Request
              </button>

            </form>

          </div>

        </div>

      )}

    </div>
  );
};

export default ProductActionsExtra;